import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { useTheme } from '@emotion/react';
import Paper from '@segment/matcha/components/Paper';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Dropdown = function Dropdown(_ref) {
  var children = _ref.children;
  var theme = useTheme();
  return _jsx(Wrapper, {
    elevation: 4,
    borderRadius: 4,
    background: theme.palette.neutrals.white[100],
    children: children
  });
};

var Wrapper = /*#__PURE__*/_styled(Paper, true ? {
  target: "e1vdwhtv0"
} : {
  target: "e1vdwhtv0",
  label: "Wrapper"
})(true ? {
  name: "1xsxug3",
  styles: "display:grid;grid-template-columns:320px 390px;max-width:710px;width:100%;overflow:hidden"
} : {
  name: "1xsxug3",
  styles: "display:grid;grid-template-columns:320px 390px;max-width:710px;width:100%;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbjIvRGVza3RvcE5hdmlnYXRpb24vRHJvcGRvd24vRHJvcGRvd24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCNkIiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9OYXZpZ2F0aW9uMi9EZXNrdG9wTmF2aWdhdGlvbi9Ecm9wZG93bi9Ecm9wZG93bi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEZDLCBQcm9wc1dpdGhDaGlsZHJlbiB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnXG5cbmltcG9ydCBQYXBlciBmcm9tICdAc2VnbWVudC9tYXRjaGEvY29tcG9uZW50cy9QYXBlcidcblxuZXhwb3J0IGNvbnN0IERyb3Bkb3duOiBGQzxQcm9wc1dpdGhDaGlsZHJlbj4gPSAoeyBjaGlsZHJlbiB9KSA9PiB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKVxuXG4gIHJldHVybiAoXG4gICAgPFdyYXBwZXIgZWxldmF0aW9uPXs0fSBib3JkZXJSYWRpdXM9ezR9IGJhY2tncm91bmQ9e3RoZW1lLnBhbGV0dGUubmV1dHJhbHMud2hpdGVbMTAwXX0+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9XcmFwcGVyPlxuICApXG59XG5cbmNvbnN0IFdyYXBwZXIgPSBzdHlsZWQoUGFwZXIpYFxuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDMyMHB4IDM5MHB4O1xuICBtYXgtd2lkdGg6IDcxMHB4O1xuICB3aWR0aDogMTAwJTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbmBcblxuZXhwb3J0IGRlZmF1bHQgRHJvcGRvd25cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Dropdown;